import { useRef, useState } from "react"
import useTokenizationForm from "@/hooks/useTokenizationForm"

export default function usePaymentInstrumentForm(setPaymentInstrumentId: Function ) {
    const [processing, setProcessing] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const iframeRef = useRef<any>(null);
    const { submitForm, clearForm: clearTokenizationForm } = useTokenizationForm(iframeRef, successCallBack, failureCallBack)

    const submit = () => {
        setProcessing(true)
        submitForm()
    };

    function successCallBack(paymentInstrumentId: string) {
        setPaymentInstrumentId(paymentInstrumentId)
    }

    function failureCallBack(message: string) {
        setErrorMessage(message)
        setProcessing(false)
    }

    function clearForm() {
        setErrorMessage('')
        setSuccessMessage('')
        clearTokenizationForm()
    }

    return { iframeRef, submit, clearForm, processing, setProcessing, errorMessage,setErrorMessage, successMessage }
}